


















































































































































































































































import { calcProgn } from '@/modules/budget-request/components/js/budgetCalcProgn';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Component, Vue, Prop } from 'vue-property-decorator';
import store from '@/services/store';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';
import CNumberInput from '@/components/c-number-input/index.vue';
import CBudgetShowSpfModal from '@/modules/budget-request/budget-event/budget-show-spf-modal.vue';
import CBudgetAgreementModal, { iAgrBtns } from '@/modules/budget-request/components/budget-sum-calc/budget-agreement-modal.vue';
import CBudgetAgreementLogModal from '@/modules/budget-request/budget-event/budget-event-agreement-log-modal.vue';

@Component({
    name: 'c-bud-event-uo',
    components: {
        'c-number-input': CNumberInput,
        'c-agr-log-modal': CBudgetAgreementLogModal,
        'c-spf-show-modal': CBudgetShowSpfModal,
        'c-budg-agr-modal': CBudgetAgreementModal
    }
})
export default class CBudgetEventUO extends Vue {
    @Prop({
        required: true
    })
    private curFilter!: any;

    @Prop({
        required: true,
        default: false
    })
    private editableProp!: boolean;

    @Prop({
        required: false,
        default: 1
    })
    private yearCountProp!: number;

    private yearCount = 1; // период планирования: 1 год или 3 года

    /**
     * при периоде "1 год" колонки curYear+1 и curYear+2 не выводятся в DOM
     */
    private get showAllYears() {
        return this.yearCount !== 1;
    }

    private get editable() {
        // пока снимок не построен, править нечего: любой ранний выход из loadData оставляет его null
        return this.editableProp && this.histDataMap !== null;
    }

    private readonly moduleCode = '004.010.003';

    private curYear: number = (new Date()).getFullYear();;
    private curRegion: any | null = null;
    private curDataType: any | null = null;
    private curVariant: any | null = null;
    private curAbp: any | null = null;
    private curProg: any | null = null;
    private curSubProg: any | null = null;
    private variantEndDate: any | null = null;
    private curCategory: any | null = null;
    private curStatus: any | null = null;

    private progress = 0;

    private dataLst: any[] = [];
    private histDataMap: Map<string, any> | null = null;
    private isDirty = false; // есть несохранённые изменения (пересчитывается по событию, а не на каждое нажатие клавиши)
    private totalSum: any = { abp_value0: 0, uo_value0: 0, abp_value1: 0, uo_value1: 0, abp_value2: 0, uo_value2: 0, chgValue0: 0, chgValue1: 0, chgValue2: 0 }

    private collapseAll = true;

    private showJustModal = false;
    private justTxt = '';

    private showCommentModal = false;
    private commentTxt = '';
    private commentEditable = false;

    private selectedProjIndx: number | null = null;

    private checkedAll = false;
    private readonly modeCode = 'br_project';
    private operationCode: string[] = []; // операции согласования
    private agrBtnLst: iAgrBtns = { back: [], forward: [] };
    private selectArr: any = [];

    private get usrId(): string | null {
        if (!store.state.user.sub) { return null; }
        return store.state.user.sub;
    }

    // ------------------------ занятость: защита от повторного нажатия кнопок
    // флаг на каждый процесс, а не один общий счётчик: процессы вложены друг в друга
    // (согласование -> сохранение -> перезагрузка), и снятие флага должно быть идемпотентным
    private loadingFl = false; // идёт загрузка данных
    private savingFl = false; // идёт сохранение
    private agreeingFl = false; // идёт согласование, включая время, пока открыта модалка
    // статус, который видел пользователь при открытии модалки согласования - отправляем на сервер
    // для проверки, что за время открытой модалки статус в БД не изменился (чужое согласование)
    private agrCurrentStatus: number | null = null;

    private loadSeq = 0; // поколение загрузки: loadData могут вызвать повторно, пока предыдущая ещё в полёте

    private get busy(): boolean {
        return this.loadingFl || this.savingFl || this.agreeingFl;
    }
    // ------------------------

    private mounted() {
        this.$emit('chgBusy', false);
        this.$watch('busy', (busy: boolean) => { this.$emit('chgBusy', busy); });
        this.$emit('chgEditable', this.editable);
        this.$watch('editable', (editable: boolean) => { this.$emit('chgEditable', editable); });
        this.curYear = this.curFilter.curYear;
        this.curRegion = this.curFilter.curRegion;
        this.curDataType = this.curFilter.curDataType;
        this.curVariant = this.curFilter.curVariant;
        this.curAbp = this.curFilter.curAbp;
        this.variantEndDate = this.curFilter.variantEndDate;
        this.curCategory = this.curFilter.category;
        this.curProg = this.curFilter.curProg;
        this.curSubProg = this.curFilter.curSubProg;
        this.curStatus = this.curFilter.curStatus
        this.yearCount = this.yearCountProp;
        this.loadData();

        this.$watch('usrId', () => {
            if (!this.usrId) { return; }
            this.loadOperations();
        })
    }

    /**
     * период планирования (1 год / 3 года) - переключается без перезагрузки данных
     */
    private chgYearCount(value: number) {
        this.yearCount = value;
    }

    private chgEvent(params: any) {
        this.curYear = params.curYear;
        this.curRegion = params.curRegion;
        this.curDataType = params.curDataType;
        this.curVariant = params.curVariant;
        this.curAbp = params.curAbp;
        this.variantEndDate = params.variantEndDate;
        this.curCategory = params.category;
        this.curProg = params.curProg;
        this.curSubProg = params.curSubProg;
        this.curStatus = params.curStatus;
        this.loadData();
    }


    private async loadData() {
        const seq = ++this.loadSeq;
        this.loadingFl = true;
        try {
            await this.loadDataInner();
        } catch (error) {
            this.progress = 100;
            makeToast(this, 'danger', this.tblTitle.load_data, (error as Error).toString());
        } finally {
            // если поверх этой загрузки уже начали новую - флаг снимет она
            if (seq === this.loadSeq) { this.loadingFl = false; }
        }
    }

    private async loadDataInner() {
        this.dataLst = [];
        this.checkedAll = false;
        this.histDataMap = null;
        this.isDirty = false; // синхронно: пока снимка нет, несохранённых изменений быть не может
        this.totalSum = { abp_value0: 0, uo_value0: 0, abp_value1: 0, uo_value1: 0, abp_value2: 0, uo_value2: 0, chgValue0: 0, chgValue1: 0, chgValue2: 0 };
        if (!this.curAbp || !this.curDataType || !this.curRegion || !this.curVariant || !this.curCategory || !this.curProg) {
            return
        }
        this.progress = 30;
        const versYear =  ((this.curDataType && this.curDataType.code == '2') ? this.curVariant.year: null);
        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, category: this.curCategory.code,  prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: -1, locale: this.$i18n.locale, vers_year: versYear, date_b: this.curVariant.date_start, date_e: this.variantEndDate };
        const loadResult = await Promise.all([
            this.loadAbpData(params),
            this.loadJustification(params),
            this.loadUoData(params),
            this.loadAgreement()
        ])
        const abpData = loadResult[0];
        const justificationData = loadResult[1];
        const uoData = loadResult[2];
        const agrMap: Map<string, any> = loadResult[3];
        if (!abpData || !justificationData || !uoData) {
            this.progress = 0;
            return;
        }
        this.getTreeData(abpData, justificationData, uoData, agrMap);
    }

    private getTreeData(abpData: any[], justData: any[], uoData: any[], agrMap: Map<string, any>) {
        abpData.sort((a: any, b: any) => (`${a.abp}_${a.prg}_${a.ppr ? a.ppr:'000'}_${a.project.code}_${a.category.code}` > `${b.abp}_${b.prg}_${b.ppr ? b.ppr:'-1'}_${b.project.code}_${b.category.code}`) ? 1 : -1);
        let result: any[] = [];
        for (let i = 0; i < abpData.length; i++) {
            const el = abpData[i];
            if (result.length == 0 || (result[result.length -1].abp != el.abp || result[result.length -1].project.code != el.project.code || result[result.length -1].prg != el.prg || result[result.length -1].ppr != el.ppr || result[result.length -1].category.code != el.category.code)) {
                const obj = { abp: el.abp, prg: el.prg, ppr: el.ppr, project: el.project, category: el.category, items: [], uo_value0: 0, uo_value1: 0, uo_value2: 0, chgValue0: 0, chgValue1: 0, chgValue2: 0, comment_txt: '', totalSum: {abp_value0: null, abp_value1: null, abp_value2: null}, collapse: this.collapseAll, justTxt: null };
                this.setJustTxt(obj, justData);
                this.setAgreement(obj, agrMap);
                this.setUoValue(obj, uoData);
                if (result.length !== 0) { result[result.length - 1].items.sort((a: any, b: any) => (a.spf > b.spf) ? 1 : -1); }
                result.push(obj);
            }
            this.setSpfObj(result[result.length-1], el);
            if (i == abpData.length - 1) { result[result.length - 1].items.sort((a: any, b: any) => (a.spf > b.spf) ? 1 : -1); }
        }

        if (uoData.length) {
            for (const el of uoData) {
                const obj = { abp: el.abp, prg: el.prg, ppr: el.ppr, project: el.project, category: el.category, items: [], uo_value0: 0, uo_value1: 0, uo_value2: 0, comment_txt: '', totalSum: {abp_value0: null, abp_value1: null, abp_value2: null}, collapse: this.collapseAll, justTxt: null };
                obj.comment_txt = el.comment_txt ? el.comment_txt : '';
                obj.uo_value0 = el.uo_value0 ? el.uo_value0: 0;
                obj.uo_value1 = el.uo_value1 ? el.uo_value1: 0;
                obj.uo_value2 = el.uo_value2 ? el.uo_value2: 0;
                this.setJustTxt(obj, justData);
                this.setAgreement(obj, agrMap);
                result.push(obj);
            }
            result.sort((a: any, b: any) => (`${a.abp}_${a.prg}_${a.ppr ? a.ppr:'000'}_${a.project.code}_${a.category.code}` > `${b.abp}_${b.prg}_${b.ppr ? b.ppr:'-1'}_${b.project.code}_${b.category.code}`) ? 1 : -1);
        }
        // --- фильтр по статусам
        if (this.curStatus?.code != null) {
            result = result.filter(obj => obj.agrObj?.status?.code === this.curStatus.code);
        }
        // -----
        for (const el of result) {
            this.calcChgValue(el, el.totalSum);
            for (let i = 0; i < 3; i++) {
                this.totalSum[`uo_value${i}`] += el[`uo_value${i}`] ?? 0;
                if (el.totalSum[`abp_value${i}`] != null) {
                    if (this.totalSum[`abp_value${i}`] == null) { this.totalSum[`abp_value${i}`] = 0; }
                    this.totalSum[`abp_value${i}`] += el.totalSum[`abp_value${i}`] ?? 0;
                }
            }
        }
        this.calcChgValue(this.totalSum, this.totalSum);
        this.dataLst = result;
        this.progress = 100;
        this.setHistDataMap(result);
    }

    private setAgreement(obj: any, agrMap: Map<string, any>) {
        const key = `${obj.abp}_${obj.prg}_${obj?.ppr ?? '00'}_${obj.project.code}`;
        const agrObj = agrMap.get(key);
        if (!agrObj) { return; }
        obj.agrObj = {};
        obj.agrObj.status = setNameLang(this.$i18n.locale, agrObj.status);
        obj.agrObj.agr_id = agrObj.id;
        obj.agrObj.update_date = agrObj.update_date;
        obj.agrObj.user_id = agrObj.user_id;
        obj.agrObj.comment_txt = agrObj.comment_txt;
        obj.editable = this.editableStep(agrObj);
        if (agrObj.availableStep) {
            obj.checked = this.checkedAll;
            obj.agrObj.availableStep = true;
        }
    }

    private editableStep(projAgr: any) {
        if (projAgr && projAgr.operation_codes) {
            for (const el of projAgr.operation_codes) {
                if (el  === 'events_uo_edit') {
                    return true;
                }
            }
        }
        return false;
    }

    private calcChgValue(objUo: any, objAbp: any) {
        objUo.chgValue0 = objUo.uo_value0 - objAbp.abp_value0 ?? 0;
        objUo.chgValue1 = objUo.uo_value1 - objAbp.abp_value1 ?? 0;
        objUo.chgValue2 = objUo.uo_value2 - objAbp.abp_value2 ?? 0;
    }

    private setHistDataMap(dataLst: any[]) {
        const newDataLst = JSON.parse(JSON.stringify(dataLst));
        const resultMap = new Map();
        for (const el of newDataLst) {
            const key = `${el.abp}_${el.prg}_${el.ppr ? el.ppr:'000'}_${el.project.code}_${el.category.code}`;
            resultMap.set(key, el);
        }
        this.histDataMap = resultMap;
        this.updDirty();
    }

    private setUoValue (obj: any, uoData: any[]) {
        if (!uoData.length) { return; }
        const indx = uoData.findIndex((el: any) => el.abp == obj.abp && el.prg == obj.prg && el.ppr == obj.ppr && el.project.code == obj.project.code && obj.category.code == el.category.code);
        if (indx >= 0) {
            const uoObj = uoData[indx];
            obj.uo_value0 = uoObj.uo_value0 ? uoObj.uo_value0: 0;
            obj.uo_value1 = uoObj.uo_value1 ? uoObj.uo_value1: 0;
            obj.uo_value2 = uoObj.uo_value2 ? uoObj.uo_value2: 0;
            obj.comment_txt = uoObj.comment_txt ? uoObj.comment_txt : '';
            uoData.splice(indx, 1);
        }
    }

    private setJustTxt (obj: any, justData: any[]) {
        if (!justData.length) { return; }
        const indx = justData.findIndex((el: any) => el.abp == obj.abp && el.prg == obj.prg && el.ppr == obj.ppr && el.project_code == obj.project.code);
        if (indx >= 0) {
            obj.justTxt = justData[indx].just_txt;
        }
    }

    private setSpfObj(abpObj: any, el: any) {
        const spfObj = { spf: el.spf, spfName: el.spfName, abp_value0: el.abp_value0, abp_value1: el.abp_value1, abp_value2: el.abp_value2 }
        for (let i = 0; i < 3; i++) {
            if (el[`abp_value${i}`]) {
                if (abpObj.totalSum[`abp_value${i}`] == null) { abpObj.totalSum[`abp_value${i}`] = 0; }
                abpObj.totalSum[`abp_value${i}`] += el[`abp_value${i}`];
            }
        }
        abpObj.items.push(spfObj);
    }

    private async loadUoData(params: any) {
        try {
            const url = '/api-py/get-budget-events-uo';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(params)
            });
            response = await response.json();
            return response;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки get-budget-events-uo', (error as Error).toString());
            return null;
        }
    }



    private async loadAbpData(params: any) {
        try {
            const url = '/api-py/get-budget-events-gu-abp-for-uotab';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(params)
            });
            response = await response.json();
            return response;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки', (error as Error).toString());
            return null;
        }
    }

    private async loadJustification(params: any) {
        try {
            const url = '/api-py/get-budget-events-justification';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(params)
            });
            response = await response.json();
            return response;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-events-justification', (error as Error).toString());
            return null;
        }
    }

    private clkCollapse(indx: number | null) {
        if (indx === null) {
            this.collapseAll = !this.collapseAll;
            for (const el of this.dataLst) {
                this.$set(el, 'collapse', this.collapseAll);
            }
        } else {
            const collapse = !this.dataLst[indx].collapse;
            this.$set(this.dataLst[indx], 'collapse', collapse);
            if (this.collapseAll && !collapse) {
                for (const el of this.dataLst) {
                    if (el.collapse) { return; }
                }
                this.collapseAll = false;
            } else if (!this.collapseAll && collapse) {
                for (const el of this.dataLst) {
                    if (!el.collapse) { return; }
                }
                this.collapseAll = true;
            }
        }
    }

    private showJust(indx: number) {
        this.selectedProjIndx = indx;
        this.justTxt = this.dataLst[indx].justTxt;
        this.showJustModal = true;
    }

    /**
     * копировать обоснование в примечание можно, только если вся строка
     * доступна для редактирования и обоснование непустое
     */
    private get justCopyable() {
        if (!this.editable || this.selectedProjIndx === null) { return false; }
        if (this.dataLst[this.selectedProjIndx].editable !== true) { return false; }
        return !!this.justTxt && this.justTxt.trim().length > 0;
    }

    /**
     * копирование обоснования АБП в примечание УО только своей строки;
     * на бэк ничего не отправляется - сохранение по кнопке "Сохранить"
     */
    private copyJustToComment() {
        if (this.selectedProjIndx === null || !this.justCopyable) { return; }
        this.$set(this.dataLst[this.selectedProjIndx], 'comment_txt', this.justTxt.trim());
        this.updDirty();
        this.showJustModal = false;
    }

    private clkJustCancel() {
        this.showJustModal = false;
    }

    private clkCommentCancel() {
        this.showCommentModal = false;
    }

    private clkShowSpf(indx: number, spfIndx: number, colum: number) {
        const elAbp = this.dataLst[indx];
        const elSpf = elAbp.items[spfIndx];
        const versYear =  ((this.curDataType && this.curDataType.code == '2') ? this.curVariant.year: null);
        const param = {
                        colum: colum,
                        variant: this.curVariant.variant_uuid,
                        abp: elAbp.abp,
                        curYear: this.curYear,
                        prg: elAbp.prg,
                        ppr: elAbp.ppr,
                        spf: elSpf.spf,
                        locale: this.$i18n.locale,
                        vers_year: versYear,
                        date_b: this.curVariant.date_start,
                        date_e: this.variantEndDate,
                        project: elAbp.project.code,
                        region: this.curRegion.code
                    };
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.spfModal.showEvent(param);
        return false;
    }

    /**
     * ввод цифр
     */
     private noAbc(evt: any) {
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
        const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
        if (!regex.test(key)) {
            evt.preventDefault();
            return false;
        }
    }

    private chgValue(obj: any, fieldNumber: string) {
        const fieldName = `uo_value${fieldNumber}`;
        if (isNaN(obj[fieldName]) || obj[fieldName]==='') { this.$set(obj, fieldName, 0); }
        obj[fieldName] = (Math.round(parseFloat(obj[fieldName]) * 10))/10;
        this.recalcTotal(fieldNumber);
        this.updDirty();
    }

    /**
     * пересчёт chgValue по всем строкам и итоговой строки this.totalSum для одного года (fieldNumber)
     */
    private recalcTotal(fieldNumber: string) {
        const fieldName = `uo_value${fieldNumber}`;
        this.totalSum[fieldName] = 0;
        for (const el of this.dataLst) {
            el[`chgValue${fieldNumber}`] = el[fieldName] - el.totalSum[`abp_value${fieldNumber}`];
            if (el[fieldName]) {
                if (this.totalSum[fieldName] == null) { this.totalSum[fieldName] = 0; }
                this.totalSum[fieldName] += el[fieldName];
            }
        }
        this.totalSum[`chgValue${fieldNumber}`] = this.totalSum[fieldName] - this.totalSum[`abp_value${fieldNumber}`];
    }

    private async copyAbpDataClk() {
        if (!this.dataLst.length) { return; }
        let fl = false;
        await this.$bvModal.msgBoxConfirm(this.tblTitle.copy_abp.text, {
            title: 'Предупреждение',
            okVariant: 'danger',
            okTitle: this.tblTitle.copy_abp.ok,
            cancelTitle: this.tblTitle.copy_abp.cancel,
            centered: true,
            size: 'lg',
            buttonSize: 'sm',
            footerClass: 'p-2',
            hideHeaderClose: false,
            noCloseOnBackdrop: true
        })
        .then(value => {
            fl = value;
        })
        .catch(err => {
            console.error(err);
        });
        if (!fl) { return; }

        for (const el of this.dataLst) {
            for (const fieldNumber of ['0', '1', '2']) {
                const abpVal = el.totalSum[`abp_value${fieldNumber}`] ?? 0;
                el[`uo_value${fieldNumber}`] = (Math.round(abpVal * 10))/10;
            }
        }
        for (const fieldNumber of ['0', '1', '2']) {
            this.recalcTotal(fieldNumber);
        }
        this.updDirty();
    }

    /**
     * изменилась ли строка относительно снимка: три суммы УО и примечание
     * (общее для getSaveArr и hasChanges - баннер и кнопка "Сохранить" не могут разойтись)
     */
    private isRowChanged(histObj: any, el: any): boolean {
        const value0 = el.uo_value0 ? el.uo_value0: null;
        const value1 = el.uo_value1 ? el.uo_value1: null;
        const value2 = el.uo_value2 ? el.uo_value2: null;
        const histVal0 = histObj.uo_value0 ? histObj.uo_value0 : null;
        const histVal1 = histObj.uo_value1 ? histObj.uo_value1 : null;
        const histVal2 = histObj.uo_value2 ? histObj.uo_value2 : null;
        const commentTxt = el.comment_txt ? el.comment_txt.trim() : '';
        const histCommentTxt = histObj.comment_txt ? histObj.comment_txt.trim() : '';
        return histVal0 !== value0 || histVal1 !== value1 || histVal2 !== value2 || histCommentTxt != commentTxt;
    }

    private getSaveArr() {
        if (!this.histDataMap) { return []; }
        const saveItems: any[] = [];
        for (const el of this.dataLst) {
            const key = `${el.abp}_${el.prg}_${el.ppr ? el.ppr:'000'}_${el.project.code}_${el.category.code}`;
            const histObj = this.histDataMap.get(key);
            if (histObj && this.isRowChanged(histObj, el)) {
                const value0 = el.uo_value0 ? el.uo_value0: null;
                const value1 = el.uo_value1 ? el.uo_value1: null;
                const value2 = el.uo_value2 ? el.uo_value2: null;
                const commentTxt = el.comment_txt ? el.comment_txt.trim() : '';
                const obj = { uo_value0: value0, uo_value1: value1, uo_value2: value2, abp: el.abp, category: el.category.code, project: el.project.code, prg: el.prg, ppr: el.ppr, comment_txt: commentTxt }
                saveItems.push(obj);
            }
        }
        return saveItems;
    }

    /**
     * есть ли отличия от снимка: тот же обход, что в getSaveArr, но с выходом на первом отличии.
     * Строки не добавляются и не удаляются, снимок построен после фильтра по статусу - совпадает с dataLst
     */
    private hasChanges(): boolean {
        if (!this.histDataMap) { return false; }
        for (const el of this.dataLst) {
            const key = `${el.abp}_${el.prg}_${el.ppr ? el.ppr:'000'}_${el.project.code}_${el.category.code}`;
            const histObj = this.histDataMap.get(key);
            if (histObj && this.isRowChanged(histObj, el)) { return true; }
        }
        return false;
    }

    private updDirty() {
        this.isDirty = this.hasChanges();
    }

    /**
     * для родителя: снять фокус с поля ввода (сработает change -> chgValue -> updDirty синхронно)
     * и вернуть, есть ли несохранённые изменения. Родитель спрашивает напрямую перед каждым переходом
     */
    public flushAndCheck(): boolean {
        const el = document.activeElement as HTMLElement | null;
        if (el && this.$el.contains(el)) { el.blur(); }
        this.updDirty();
        return this.isDirty;
    }

    /**
     * сохранение перед уходом со вкладки или сменой фильтра: без перезагрузки,
     * таблицу дальше перезагружает каскад фильтра либо уничтожение вкладки
     */
    public async saveBeforeLeave(): Promise<boolean> {
        const ok = await this.saveClk(false);
        if (!ok) { return false; }
        // данные сохранены без перезагрузки - обновляем снимок, иначе те же изменения снова считаются несохранёнными
        this.setHistDataMap(this.dataLst);
        return true;
    }

    /**
     * отказ от несохранённых правок: таблица пустая до прихода новых данных,
     * иначе при обрыве каскада фильтра старые правки остались бы на экране без баннера
     */
    public discardChanges() {
        this.dataLst = [];
        this.histDataMap = null;
        this.isDirty = false;
        this.totalSum = { abp_value0: 0, uo_value0: 0, abp_value1: 0, uo_value1: 0, abp_value2: 0, uo_value2: 0, chgValue0: 0, chgValue1: 0, chgValue2: 0 };
    }

    private async saveClk(flLoad = true): Promise<boolean> {
        if (this.savingFl) { return false; } // сохранение уже идёт
        this.savingFl = true;
        try {
            return await this.saveClkInner(flLoad);
        } catch (error) {
            makeToast(this, 'danger', this.tblTitle.saving, (error as Error).toString());
            return false;
        } finally {
            this.savingFl = false;
        }
    }

    private async saveClkInner(flLoad: boolean): Promise<boolean> {
        if (!this.histDataMap) { return false; }
        const saveItems: any[] = this.getSaveArr();

        if (!saveItems.length) {
            makeToast(this, 'warning', 'Сообщение', 'Нет изменений для сохранения');
            return false;
        }
        const saveObj = { curYear: this.curYear, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, userId: this.usrId, items: saveItems, locale: this.$i18n.locale };
        try {
            const url = '/api-py/save-budget-events-uo';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
            response = await response.json();
            let success = true;
            for (const r of response) {
                if (r.result !== 'success') {
                    success = false;
                    if (r.result == 'warning') {
                        makeToast(this, 'warning', 'Сообщение', r.errTxt);
                    } else {
                        makeToast(this, 'danger', 'Сообщение', `${this.tblTitle.saving} ${r.result}`);
                    }
                }
            }
            if (success) {
                makeToast(this, 'success', this.tblTitle.saving, this.tblTitle.data_saved);
                if (flLoad) {
                    this.loadData();
                }
            }
            return success;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка сохранения', (error as Error).toString());
            return false;
        }
    }

    private editComment(indx: number) {
        this.selectedProjIndx = indx;
        this.commentTxt = this.dataLst[indx].comment_txt;
        this.commentEditable = this.dataLst[indx].editable;
        this.showCommentModal = true;
    }

    private saveCommentTxt() {
        if (this.selectedProjIndx == null) { return; }
        this.showCommentModal = false;
        this.dataLst[this.selectedProjIndx].comment_txt = this.commentTxt.trim();
        this.updDirty();
    }


    // ---------- согласование
    private clkCheck(indx: number | null) {
        if (indx === null) {
            for (const el of this.dataLst) {
                if (el.checked !== undefined && el.checked !== null) {
                    el.checked = this.checkedAll;
                }
            }
            return;
        }
    }

    private async loadOperations() {
        this.operationCode = [];
        if (this.usrId === null) {
            this.$emit('chgAgrAccess', false);
            return;
        }
        let result = null;
        try {
            result = await fetch(encodeURI(`/api/um/module/link?user=${this.usrId}&modulecode=${this.moduleCode}`));
            if (result.status === 200) {
                result = await result.json();
            }  else {
                if (result.status !== 404) { makeToast(this, 'danger', 'Ошибка загрузки операций пользователя', `${result.status}  ${result.statusText}`); }
                return;
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки операций пользователя', (error as Error).toString());
            return;
        }
        if (result.operations) {
            for (const el of result.operations) {
                this.operationCode.push(el);
            }
        }
        this.$emit('chgAgrAccess', this.operationCode.length > 0);
    }

    private async loadAgreement() {
        if (!this.operationCode.length) { await this.loadOperations(); }
        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, mode_code: this.modeCode, operation_code: this.operationCode,  prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: -1 };
        let result = null;
        try {
            const response: any = await fetch(`/api-py/get-budget-event-agreement-uo/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                result = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка get-budget-event-agreement-uo',  `${response.status} - ${response.statusText}`);
                return new Map();
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-event-agreement-uo', (error as Error).toString());
            return new Map();
        }
        return this.getAgrMap(result);
    }

    private getAgrMap(agrLst: any[]) {
        const result = new Map<string, any>();
        for (const el of agrLst) {
            const key = `${el.abp}_${el.prg}_${el?.ppr ?? '00'}_${el.project_code}`;
            result.set(key, el)
        }
        return result;
    }

    private agrLogClk(indx: number) {
        const agr = this.dataLst[indx].agrObj;
        const id = agr.agr_id;
        if (id == null) { return; }
        let agrObj: any = null;
        if (agr) {
            agrObj = {
                userId: agr.user_id,
                status: agr.status.code,
                name_ru: agr.status ? agr.status.name_ru: '',
                name_kk: agr.status ? agr.status.name_kk: '',
                name_en: agr.status ? agr.status.name_en: '',
                updateDate: agr.update_date,
                commentTxt: agr.comment_txt
            }
        }
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refAgrLogModal.showEvent(id, agrObj);
    }

    private async checkAgrEventSaved() {
        const saveArr: any[] = this.getSaveArr();
        if (!saveArr.length) {
            return true;
        }
        let fl = false
        await this.$bvModal.msgBoxConfirm(this.tblTitle.check_agr_event_saved.text, {
            title: 'Предупреждение',
            okVariant: 'success',
            okTitle: this.tblTitle.check_agr_event_saved.yes,
            cancelTitle: this.tblTitle.check_agr_event_saved.cancel,
            centered: true,
            size: 'lg',
            buttonSize: 'sm',
            footerClass: 'p-2',
            hideHeaderClose: false,
            noCloseOnBackdrop: true
        })
        .then(value => {
            fl = value;
        })
        .catch(err => {
            console.error(err);
        });
        if (!fl) { return false; }
        const flSaved = await this.saveClk(false);
        if (!flSaved) { return false; }
        // данные сохранены без перезагрузки - обновляем снимок, иначе те же изменения снова считаются несохранёнными
        this.setHistDataMap(this.dataLst);
        return true;
    }

    private async agreementEvent() {
        if (this.busy) { return; }
        this.agreeingFl = true;
        let modalOpened = false;
        try {
            modalOpened = (await this.agreementEventInner()) === true;
        } catch (error) {
            makeToast(this, 'danger', 'Согласование', (error as Error).toString());
        } finally {
            // если модалка открыта - флаг снимет agrClk или её закрытие (@closed)
            if (!modalOpened) { this.agreeingFl = false; }
        }
    }

    private async agreementEventInner() {
        const selectArr: any = [];
        this.selectArr = [];
        this.agrBtnLst = { back: [], forward: [] };
        let firstStatus: number | null = null;
        const notSameStatus = this.getBudgetText('other.notSameStatus'); // Выберите подпрограммы с одинаковым статусом
        const title = this.getBudgetText('other.no_program[0]'); // Согласование
        for (const el of this.dataLst) {
            if (el.checked) {
                if (firstStatus === null) { firstStatus = el.agrObj.status.code; }
                if (firstStatus !== el.agrObj.status.code) {
                        makeToast(this, 'danger', title, `${notSameStatus}!`);
                        return;
                }
                if (el.agrObj.agr_id!= null) {
                    selectArr.push({ id: el.agrObj.agr_id });
                }
            }
        }
        if (selectArr.length === 0) {
            const nonSelected = this.getBudgetText('other.no_program[1]'); // Не выбрано ни одной программы/подпрограммы
            makeToast(this, 'warning', title, nonSelected);
            return;
        }

        this.selectArr = selectArr;

        const flCheckSaved = await this.checkAgrEventSaved();
        if (!flCheckSaved) { return; }
        // ---------------
        this.agrCurrentStatus = firstStatus;
        const params = { modeCode: this.modeCode, operationCode: this.operationCode, agrCode: firstStatus };

        let result: any = null;
        try {
            const response: any = await fetch(`/api-py/get-agreement-step-next-back/${encodeURI(JSON.stringify(params))}`);
            result = await response.json();
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-agreement-step-next-back', (error as Error).toString());
            this.progress = 0;
            return;
        }
        if (result.length === 0) {
            makeToast(this, 'warning', 'Согласование', 'Нет доступных шагов согласования!');
            return;
        }
        for (const el of result) {
            let name = el[`name_${this.$i18n.locale}`];
            if (!name) { name = el.name_ru; }
            el.name = name;
            if (el.stepType === 1) {
                this.agrBtnLst.back.push(el);
            } else {
                this.agrBtnLst.forward.push(el);
            }
        }
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refAgrModal.showEvent();
        return true;
    }

    /**
     * закрытие модалки согласования без действия - снимаем флаг занятости
     */
    private agrModalClosed() {
        this.agreeingFl = false;
    }

    private async agrClk(data: any) {
        try {
            const obj = Object.assign({
                    cur_year: this.curYear,
                    region: this.curRegion.code,
                    variant: this.curVariant.variant_uuid,
                    data_type: this.curDataType.code,
                    abp: this.curAbp.abp
                }, data);
            await this.saveAgreement(obj, '/api-py/set_b_event_agreement_step_proj');
        } catch (error) {
            makeToast(this, 'danger', 'Сохранение status', (error as Error).toString());
        } finally {
            this.agreeingFl = false; // согласование завершено, модалка уже закрыта самой clkBtn
        }
    }

    private async saveAgreement(data: any, url: string) {
        data.userId = store.state.user.sub;
        data.locale = this.$i18n.locale;
        data.currentStatus = this.agrCurrentStatus; // статус, который видел пользователь - для проверки на сервере
        data.module_code = this.moduleCode; // зона проверки обязательности категории: "Свод УО" в неё входит
        const saveObj = Object.assign({
            userId: this.usrId,
            items: this.selectArr,
        }, data);
        let result: any = await fetch(url,
            {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
        if (result.status === 200) {
            result = await result.json();
            for (const res of result) {
                if (res.result === 'error') {
                    makeToast(this, 'danger', 'Сохранение status', `${res.errTxt}`);
                    console.error(`Ошибка ${url}`, res);
                    return;
                }
            }
            this.loadData();
        } else {
            makeToast(this, 'danger', 'Сохранение status', `Ошибка ${result.status} ${result.statusText}`);
            return;
        }
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get tblTitle() {
        const obj = {
            saving: this.getBudgetText('sum_calc_edit.saving'), // Сохранение
            data_saved: this.getBudgetText('sum_calc_edit.data_saved'), // Данные сохранены
            load_data: this.getBudgetText('sum_calc_edit.load_data'), // Загрузка данных
            status: this.getBudgetText('sum_calc_abp.status'), // Статус
            change_log: this.getBudgetText('sum_calc_abp.change_log'), // Журнал изменений
            copy_just_to_comment: this.getBudgetText('budget-event.copy-just-to-comment'), // Копировать в примечание
            unsaved_banner: this.getBudgetText('budget-event.unsaved-changes.banner'), // Внимание: Есть несохраненные изменения!
            check_agr_event_saved: {
                text: this.getBudgetText('budget-event.check-agr-event-saved.text'), // Есть несохраненные изменения. Сохранить перед отправкой?
                yes: this.getBudgetText('budget-event.check-agr-event-saved.yes'), // Сохранить и продолжить
                cancel: this.getBudgetText('budget-event.check-agr-event-saved.cancel'), // Отменить
            },
            copy_abp: {
                text: this.getBudgetText('budget-event.copy-abp.text'), // Вы копируете "суммы, заявленные АБП" в "суммы, предлагаемые УО"...
                ok: this.getBudgetText('budget-event.copy-abp.ok'), // Подтвердить
                cancel: this.getBudgetText('budget-event.copy-abp.cancel'), // Отменить
            },
            uo_zero_before_send_warning: this.getBudgetText('budget-event.uo-zero-before-send-warning'), // предупреждение в модалке согласования: ненулевые суммы УО блокируют смену категории у АБП
        }
        return obj
    }
}
